import Axios from "../config/Axios";
import {
    GET_ALL_WORKSPACES_REQUEST,
    GET_ALL_WORKSPACES_SUCCESS,
    GET_ALL_WORKSPACES_FAIL,
    GET_CURRENT_WORKSPACE_REQUEST,
    GET_CURRENT_WORKSPACE_SUCCESS,
    GET_CURRENT_WORKSPACE_FAIL,
    CREATE_WORKSPACE_REQUEST,
    CREATE_WORKSPACE_SUCCESS,
    CREATE_WORKSPACE_FAIL,
    CREATE_WORKSPACE_INITIAL_REQUEST,
    CREATE_WORKSPACE_INITIAL_SUCCESS,
    CREATE_WORKSPACE_INITIAL_FAIL,
    EDIT_WORKSPACE_REQUEST,
    EDIT_WORKSPACE_SUCCESS,
    EDIT_WORKSPACE_FAIL,
} from '../constants/workspaceConstants';

const fetchAllWorkspaces = () => async (dispatch, getState) => {
    try {
        dispatch({
            type: GET_ALL_WORKSPACES_REQUEST,
        })

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                // 'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            }
        }

        const { data } = await Axios.get("/workspace/workspaces", config);

        dispatch({
            type: GET_ALL_WORKSPACES_SUCCESS,
            payload: data
        })

    } catch (error) {
        dispatch({
            type: GET_ALL_WORKSPACES_FAIL,
            payload: error.message,
        })
    }
}

const setCurrentWorkSpace = (workspaceData) => async (dispatch) => {
    try {
        dispatch({
            type: GET_CURRENT_WORKSPACE_REQUEST,
        })

        dispatch({
            type: GET_CURRENT_WORKSPACE_SUCCESS,
            payload: workspaceData
        })

    } catch (error) {
        dispatch({
            type: GET_CURRENT_WORKSPACE_FAIL,
            payload: error.message,
        })
    }
}

const createWorkSpaceInitial = (workspaceData) => async (dispatch) => {
    try {
        dispatch({
            type: CREATE_WORKSPACE_INITIAL_REQUEST,
        })

        dispatch({
            type: CREATE_WORKSPACE_INITIAL_SUCCESS,
            payload: workspaceData
        })

    } catch (error) {
        dispatch({
            type: CREATE_WORKSPACE_INITIAL_FAIL,
            payload: error.message,
        })
    }
}

const createWorkSpace = (workspaceData) => async (dispatch, getState) => {
    try {
        dispatch({
            type: CREATE_WORKSPACE_REQUEST,
        })

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                // 'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            }
        }

        const { data } = await Axios.post("/workspace/create", workspaceData, config);

        dispatch({
            type: CREATE_WORKSPACE_SUCCESS,
            payload: data
        })

    } catch (error) {
        dispatch({
            type: CREATE_WORKSPACE_FAIL,
            payload: error.message,
        })
    }
}

const editWorkSpace = (workspaceData) => async (dispatch, getState) => {
    try {
        dispatch({
            type: EDIT_WORKSPACE_REQUEST,
        })

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                // 'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            }
        }

        const { data } = await Axios.post("/workspace/edit", workspaceData, config);

        dispatch({
            type: EDIT_WORKSPACE_SUCCESS,
            payload: data
        })

    } catch (error) {
        dispatch({
            type: EDIT_WORKSPACE_FAIL,
            payload: error.message,
        })
    }
}

export {
    fetchAllWorkspaces,
    setCurrentWorkSpace,
    createWorkSpaceInitial,
    createWorkSpace,
    editWorkSpace
}